@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/text-helpers.scss';
@import 'apps/webcomponents/src/xdr/sensors/base/styles/common.scss';

.sensor-data-list {
  gz-form-field {
    flex: none;
  }
}

#google_workspace_service_label {
  margin-top: 30px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: var(--body-size);
  color: var(--body-text-arrows-400);
}

#google_workspace_admin_label {
  font-weight: bold;
  font-size: var(--body-size);
  color: var(--body-text-arrows-400);
}

#label_for_google_workspace_sa_details_file {
  font-size: var(--body-size);
  color: var(--body-text-arrows-400);
}

#google_workspace_sa_details_file {
  margin-bottom: 10px;
}

#google_workspace_private_key {
  width: 664px;
}
